module.exports = __webpack_public_path__ + "static/media/sample-vehicles.9bed5fb4.xlsx";